<template>
  <q-card class="login-card row col-lg-5 col-md-5 col-sm-12 no-border-radius">
    <q-card-section class="col-12 text-center">
      <div>
        <img src="~assets/logoWaste.png" class="system-logo" />
      </div>
      <q-item-label class="login-title">
        <translate>DOLOGIN</translate>
      </q-item-label>

      <q-input
        v-model="loginController.email"
        type="text"
        name="email"
        :placeholder="$gettext('USER')"
        borderless
        class="input-login"
      >
        <template v-slot:prepend>
          <q-icon
            name="account_circle"
            class="text-primary"
            style="font-size: 1.5em"
          />
        </template>
      </q-input>

      <q-input
        v-model="loginController.password"
        type="password"
        @keydown.enter.prevent="loginController.login()"
        name="password"
        :placeholder="$gettext('PASSWORD')"
        borderless
        class="input-login"
      >
        <template v-slot:prepend>
          <q-icon name="lock" class="text-primary" style="font-size: 1.5em" />
        </template>
      </q-input>

      <div class="absolute-bottom btns-container">
        <q-btn
          class="btn-login"
          :disabled="!loginController.isValidLoggIn"
          name="btn_logar"
          @click="loginController.login()"
        >
          <translate>LOGIN</translate>
        </q-btn>
        <q-btn
          class="btn-login-google"
          name="btn_logar_google"
          @click="googleAuth"
        >
          <q-icon left size="13px" name="fab fa-google" />
          <translate>GOOGLE_LOGIN</translate>
        </q-btn>
      </div>
    </q-card-section>
  </q-card>
</template>
<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { QCard, QCardSection, QBtn, QField, QInput, QIcon } from 'quasar'
import { LoginController } from '../LoginController'
import {
  GoogleAuthProvider,
  signInWithPopup,
  EmailAuthProvider,
  getAuth,
  createUserWithEmailAndPassword
} from 'firebase/auth'
import * as firebaseui from 'firebaseui'
import { firebase } from 'src/boot/firebase'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  name: 'login-form',
  components: {
    QCard,
    QCardSection,
    QBtn,
    QField,
    QInput,
    QIcon
  }
})
export default class LoginForm extends Vue {
  loginController = LoginController.getInstance();

  googleAuth () {
    const provider = new GoogleAuthProvider()
    provider.addScope('https://www.googleapis.com/auth/contacts.readonly')
    const auth = getAuth(firebase)
    auth.languageCode = 'pt_BR'
    signInWithPopup(auth, provider)
      .then((result) => {
        const user = result.user
        const token = user.accessToken
        this.loginController.loginWithGoogle({
          idToken: token,
          profile: user
        })
        // ...
      })
      .catch((error) => {
        console.error(error)
      })
  }
}
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.system-logo {
  margin-inline-end: 0.5rem;
  margin-inline-start: 0.3rem;
  margin-bottom: -6px;
  width: 50%;
}

.login-card {
  background: rgba(255, 255, 255, 0.7);
  flex-grow: 0.1;
  padding: 4% 10px 0px;
}

.login-card .login-title {
  flex: 1 1 100%;
  font-size: 1rem;
  font-weight: 400;
  margin: 50px 0px 10px;
}

.input-login {
  background: rgb(232, 240, 254);
  border-radius: 5px;
  padding: 0px 10px;
  margin: 10px 0px;
}

.message-error {
  color: $negative;
  font-weight: 500;
  margin: 20px 0px 0px;
}

.btn-login-google, .btn-login {
  font-size: 1rem;
  padding: 0px 60px;
  text-align: center;
  margin-bottom: 50px;
  color: #FFFFFF;
  background-color: #830119;
}

.btn-login-google {
  font-size: 14px;
}

.btns-container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
}

@media only screen and (max-width: 768px) {
  .login-card {
    padding: 10px 10px 80px 10px;
  }

  .btn-login {
    margin-bottom: -80px;
  }
}
</style>
